import StandardReturnStatus from "@dana/Components/StandardReturnsOrderStatus/StandardReturnStatus";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import getStandardReturnOrders from "@dana/Store/Data/StandardReturnsStatus/Handlers/StandardReturnsStatusHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCountries from "@insite/client-framework/Store/Data/Countries/Handlers/LoadCurrentCountries";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Page, { PageProps as MobiusPageProps } from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationStateDana) => ({
    session: getSession(state),
    cart: getCurrentCartState(state),
});

export interface StandardReturnsPageStyles {
    page?: MobiusPageProps;
    outerGridContainer?: GridContainerProps;
    innerGridContainer?: GridContainerProps;
    outerGridItem?: GridItemProps;
    innerGridItem?: GridItemProps;
    wrapper?: InjectableCss;
}

export const StandardReturnsPageStyles: StandardReturnsPageStyles = {
    page: {
        background: themeBackgrounds.offWhite,
        fullWidth: [true, true, true, true, true],
    },
    outerGridContainer: {
        gap: 0,
    },
    innerGridContainer: {
        gap: 0,

        offsetCss: css`
            gap: 16px;
        `,
    },
    outerGridItem: {
        width: 12,
    },
    innerGridItem: {
        width: 12,
    },
    wrapper: {
        css: css`
            width: 100%;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding: 0 16px;
                            padding-bottom: 24px;
                        `,
                        css`
                            padding: 0 24px;
                            padding-bottom: 32px;
                        `,
                        css`
                            padding: 0 24px;
                            padding-bottom: 60px;
                        `,
                        css`
                            padding: 0 40px;
                            padding-bottom: 80px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
};

const mapDispatchToProps = {};

type Props = ResolveThunks<typeof mapDispatchToProps> & PageProps & ReturnType<typeof mapStateToProps>;
const styles = StandardReturnsPageStyles;
const StandardReturnsPage: React.FC<Props> = ({ id, session }) => {
    const [isLoading, setIsLoading] = React.useState(true);

    React.useEffect(() => {
        setIsLoading(false);
    }, [session]);

    return (
        <Page {...styles.page}>
            <LoadingOverlay loading={isLoading}>
                <GridContainer {...styles.outerGridContainer}>
                    <GridItem {...styles.outerGridItem}>
                        <StyledWrapper {...styles.wrapper}>
                            <GridContainer {...styles.innerGridContainer}>
                                <GridItem {...styles.innerGridItem}>
                                    <StandardReturnStatus />
                                </GridItem>
                            </GridContainer>
                        </StyledWrapper>
                    </GridItem>
                </GridContainer>
            </LoadingOverlay>
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(StandardReturnsPage),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "Content",
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "MyProfilePage" instead of this constant.
 */
export const StandardReturnsPageContext = "StandardReturnsPage";
